import { Component, Input, OnInit, ViewChild } from '@angular/core';
import { AnimationDefinitions } from '@meddev/fe-shared';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { ReservationMode } from '../../../_shared/enums/reservationMode.enum';
import { Asset, Contractor, Customer, ReservationRequest, Service } from '../../../_shared/model';
import { StorageService } from '../../../_shared/services';
import { TermFormComponent } from '../term-form/term-form.component';

@Component({
    selector: 'app-term-popup',
    templateUrl: './term-popup.component.html',
    styleUrls: ['./term-popup.component.scss'],
    animations: [AnimationDefinitions.ExpandCollapseWidth, AnimationDefinitions.ExpandCollapseHeight],
})
export class TermPopupComponent implements OnInit {
    public isNewCustomer = false;
    // TODO Ignored with eslint-interactive on 2023-11-10
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    public reservationTypes: any = ReservationMode;
    // @Input()
    // public isEditMode: boolean = false;

    @Input()
    public termType: ReservationMode;
    @Input()
    public resRequestData: ReservationRequest;

    @Input()
    customerForTerm: Customer;
    @Input()
    // TODO Ignored with eslint-interactive on 2023-11-10
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    selectedDate: any;
    @Input()
    selectedTime = '';
    @Input()
    selectedTimeEnd = '';
    @Input()
    selectedService: Service;
    @Input()
    selectedSubcontractor: Contractor;
    @Input()
    selectedAsset: Asset;
    @Input()
    create: string;
    @Input()
    disableDateChange = false;
    @Input()
    popupTitle: string;
    @Input()
    genericTitle: string;
    @Input()
    termComment: string;
    @Input()
    // TODO Ignored with eslint-interactive on 2023-11-10
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    businessHours: any;
    @Input()
    // TODO Ignored with eslint-interactive on 2023-11-10
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    allData: any;
    @Input()
    isCase = false;

    public isGenericTermSwitch = false;
    @ViewChild('termForm', { static: true })
    termForm: TermFormComponent;
    public customerForEdit: Customer;
    public showCustomerDetailsForm = false;
    public showPayerDetailsForm = false;

    // TODO Ignored with eslint-interactive on 2023-11-10
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    public isInputVisible: any = {
        termTypeSwitcher: true,
        buttons: {
            draft: true,
        },
    };

    // public termForm: TermFormComponent;
    constructor(
        public activeModal: NgbActiveModal,
        public storage: StorageService,
    ) {}

    ngOnInit() {
        this.validateVisibleInputs();
    }

    public validateVisibleInputs(): void {
        if (
            this.resRequestData.reservationMode === ReservationMode.INTERNAL ||
            this.resRequestData.isEditMode ||
            this.resRequestData.reservationMode === ReservationMode.VISIT ||
            this.termType === ReservationMode.QUEUE ||
            this.resRequestData.reservationMode === ReservationMode.QUEUE
        ) {
            this.isInputVisible.buttons.draft = false;
            this.isInputVisible.termTypeSwitcher = false;
        }
    }

    public submitForm(): void {
        // if (this.isGenericTerm) {
        //     this.termForm.onSubmitNewGenericTerm();
        // } else {
        // this.termForm.isEditMode = this.isEditMode;
        // this.termForm.editModel = this.editModel;
        this.termForm.onSubmitNewTerm();
        this.customerForEdit = undefined;
        // this.termForm.create = ReservationTypes.RESERVE;

        // }
    }

    public submitDraftForm(): void {
        // this.termForm.isEditMode = this.isEditMode;
        // this.termForm.editModel = this.editModel;
        // this.termForm.create = ReservationTypes.DRAFT;
        this.termForm.onSubmitDraftTerm();
        this.customerForEdit = undefined;
    }

    public showCustomerEditForm(customer: Customer): void {
        this.showCustomerDetailsForm = true;
        this.termForm.addTermForm.disable();
        this.customerForEdit = customer;
    }

    // TODO Ignored with eslint-interactive on 2023-11-10
    // eslint-disable-next-line @typescript-eslint/no-unused-vars, @typescript-eslint/no-explicit-any
    public cancelCustomerEdit(cancle: any): void {
        this.termForm.addTermForm.enable();
        this.showCustomerDetailsForm = false;
        this.customerForEdit = undefined;
    }

    public onCancelPayerDialog(): void {
        this.termForm.addTermForm.enable();
        this.showPayerDetailsForm = false;
    }

    // TODO Ignored with eslint-interactive on 2023-11-10
    // eslint-disable-next-line @typescript-eslint/no-unused-vars, @typescript-eslint/no-explicit-any
    public showNewCustomerForm(value: any): void {
        this.showCustomerDetailsForm = true;
        this.termForm.addTermForm.disable();
        this.isNewCustomer = true;
    }

    // TODO Ignored with eslint-interactive on 2023-11-10
    // eslint-disable-next-line @typescript-eslint/no-unused-vars, @typescript-eslint/no-explicit-any
    public showNewPayerForm(value: any): void {
        this.showPayerDetailsForm = true;
        this.termForm.addTermForm.disable();
        this.isNewCustomer = true;
    }

    public saveCustomer(customer: Customer): void {
        if (customer) {
            this.termForm.addTermForm.controls['customer'].setValue(customer);
        }
        this.termForm.addTermForm.enable();
        this.showCustomerDetailsForm = false;
        this.customerForEdit = undefined;
    }

    public onSavePayer(): void {
        this.termForm.addTermForm.enable();
        this.showPayerDetailsForm = false;
        this.termForm.reloadPayers();
    }

    public changeTermType(): void {
        if (this.isGenericTermSwitch) {
            this.termType = ReservationMode.INTERNAL;
            this.resRequestData.reservationMode = ReservationMode.INTERNAL;
            this.termForm.showFormForGeneric();
        } else {
            this.termType = ReservationMode.RESERVE;
            this.resRequestData.reservationMode = ReservationMode.RESERVE;
            this.termForm.createForm();
        }
        this.termForm.validateVisibleInputs();
        this.isInputVisible.buttons.draft = !this.isGenericTermSwitch;
        //TODO
        // this.termForm.addTermForm.controls['start'].setValue(this.resRequestData.selectedDate);
        // this.termForm.addTermForm.controls['startTime'].setValue(this.resRequestData.selectedTime);

        // if (this.isGenericTerm) {
        //     this.termForm.addTermForm.removeControl('customer');
        // }
        // this.termForm.addTermForm.reset();
    }
}
